import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  videoSearchInput: '',
  uploadVideoModalState: false,
  currentPage: 1,
  videoUploadSuccess: false,
  bulkCurrentPage: 1,
};

export const uploadVideo = createSlice({
  name: 'uploadVideo',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setUploadVideoModalState: (state, action) => {
      state.uploadVideoModalState = action.payload;
    },
    setVideoSearchInput: (state, action) => {
      state.videoSearchInput = action.payload;
    },
    setVideoUploadSuccess: (state, action) => {
      state.videoUploadSuccess = action.payload;
    },
    setBulkCurrentPage: (state, action) => {
      state.bulkCurrentPage = action.payload;
    },
  },
});

export const {
  setCurrentPage,
  setBulkCurrentPage,
  setUploadVideoModalState,
  setVideoSearchInput,
  setVideoUploadSuccess,
} = uploadVideo.actions;

export default uploadVideo.reducer;
